"use strict";
/* Imports and exports for webpack */

// Expose all clipping functions to the global scope, as an object called `greinerHormann`.
globalThis.greinerHormann = require("./index.js");
